export default __webpack_public_path__ + "static/media/img11.5e2778a2.JPG";